import React from "react";
import Landing from "../../../themes";

const Disclosure: React.FC = () => {
  return (
    <Landing className="font-abel">
      <div className="bg-whirl bg-contain">
        <div className="max-w-[1250px] mx-auto px-3 md:py-12 py-8 text-[#000000]">
          <div>
            <h1 className="text-3xl md:text-5xl font-[700] pb-3">
              Disclosure & Industry Standards
            </h1>
            <section className="font-abel my-4">
              <p className="text-[15px] md:text-[20px] pb-2">
                25th and Staffing model and fee adjustment (true-up) process
                align with international best practices in retained executive
                search.
              </p>
              <p className="text-[15px] md:text-[20px] pb-2">
                Executive search fees are calculated as a percentage of the
                candidate’s guaranteed first-year compensation. When that
                compensation changes within the first year due to a raise,
                promotion, or retention adjustment. It is standard practice for
                global executive search firms to reconcile (true-up) the fee to
                reflect the updated package.
              </p>
              <p className="text-[15px] md:text-[20px] pb-2">This ensures:</p>
              <ul
                typeof="square"
                className="privacy-list text-[15px] md:text-[20px] line-height: 1.5rem; text-[#000000]"
              >
                <li>
                  Fairness: You only pay in proportion to the actual guaranteed
                  compensation.
                </li>
                <li>
                  Transparency: Disclosure of compensation changes protects your
                  replacement guarantee and partnership integrity.
                </li>
                <li>
                  Global alignment: Consistent with policies followed by major
                  executive firms in the U.S. and internationally.
                </li>
              </ul>
              <p className="text-[15px] md:text-[20px] pb-2 pt-2">
                Supporting Industry References
              </p>
              <ul
                typeof="square"
                className="privacy-list text-[15px] md:text-[20px] line-height: 1.5rem; text-[#000000] pb-2"
              >
                <li>
                  <a
                    href="https://ir.kornferry.com/sec-filings/all-sec-filings/content/0001628280-25-011917/0001628280-25-011917.pdf?utm_source=chatgpt.com"
                    className="text-primary"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Korn Ferry (2025 10-K, p. 66)
                  </a>
                  : “An uptick fee is billed when the actual compensation
                  awarded by the client for a placement is higher than the
                  estimated compensation.”
                </li>
                <li>
                  <a
                    href="https://investors.heidrick.com/financial-information/annual-reports?utm_source=chatgpt.com"
                    className="text-primary"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Heidrick & Struggles Annual Report (2024, p. 47)
                  </a>
                  : Notes fee reconciliation where final compensation differs
                  from initial estimates.
                </li>
                <li>
                  <a
                    href="https://ajcunet.edu/wp-content/uploads/2025/02/RRA-Proposal.pdf?utm_source=chatgpt.com"
                    className="text-primary"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Russell Reynolds Associates Terms of Engagement (2023)
                  </a>
                  : States that invoices are based on the candidate’s final
                  guaranteed compensation at acceptance.
                </li>
                <li>
                  <a
                    href="https://www.bain.com/insights/its-in-the-contract-or-is-it/?utm_source=chatgpt.com"
                    className="text-primary"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Bain & Company – "It's in the Contract, or Is It?
                  </a>{" "}
                  Bain & Company's contract governance research highlights that
                  organizations often lose revenue by failing to enforce
                  contractual adjustments when terms change. This reinforces the
                  importance of reconciliation clauses in retained search
                  agreements to maintain financial and operational alignment.
                </li>
              </ul>
              <p className="text-[15px] md:text-[20px] pb-2"></p>
              <p className="text-[15px] md:text-[20px] pb-2">
                These confirm that first year compensation adjustments commonly
                referred to as a “true-up” or “reconciliation” are standard
                across global executive search firms. This ensures fairness,
                transparency, and alignment between client success and recruiter
                accountability.
              </p>
            </section>
          </div>
        </div>
      </div>
    </Landing>
  );
};

export default Disclosure;
